import { Table } from '@octano/global-ui';
import { useColumns } from './hooks/useColumns';
import { useTexts } from './hooks/useTexts';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';

type StudentsRemovalRequestsResolvedTableProps = {
  data: any[];
  loading: boolean;
};

export function StudentsRemovalRequestsResolvedTable({
  data,
  loading,
}: StudentsRemovalRequestsResolvedTableProps) {
  const texts = useTexts().empty;
  const columns = useColumns();

  return (
    <Table
      columns={columns}
      data={data}
      isLoadingResults={loading}
      noResultsText={
        <TableEmptyContent
          title={texts.noResults.title}
          subtitle={texts.noResults.body}
        />
      }
    />
  );
}
